import './style.css'

export const Home = () => {
  return(
    <>
    <header>
    <h1>bem-vindo ao comandos.dev</h1>
</header>

<div className="container">
    <p>aqui, você encontra uma plataforma pensada para centralizar os comandos mais essenciais para desenvolvedores, facilitando o acesso a informações importantes em um único lugar. Nosso objetivo é simplificar sua jornada, reunindo tudo de forma prática e acessível, para que você tenha uma experiência mais eficiente e menos confusa.</p>

    <h2>sua colaboração é muito importante!</h2>
    <p>se tiver sugestões de melhorias ou quiser apoiar essa iniciativa, entre em contato com a gente. Seu feedback será fundamental para continuar aprimorando o comandos.dev e tornar a plataforma ainda mais útil para todos.</p>

    <h2>siga-nos e fique por dentro!</h2>
    <p>confira nossos canais de contato para saber como você pode colaborar e apoiar nosso projeto.</p>
</div>
    </>
  );
};